import React, { useContext } from "react";
import { SalesContext } from "./../../Context/SalesContext";

import SuccessIcon from './../../Components/Common/Svg/SuccessIcon';
import './LocationConfirmation.css';

export default () => {
    const context = useContext(SalesContext);

    const changeAddressClickHandler = () => {
        window.location.href = "/vodacom/fibre/sales/leads";
    }

    return (
        <div className="location-confirmation-address-container">
            <div className="location-confirmation-success-icon"><SuccessIcon /></div>
            <div className="location-confirmation-heading" automationid="SalesLead_Div_ChoosePlanHeading_0">Great news! Fibre is available in your area. Please choose a plan.</div>
            <p className="location-confirmation-installation-address">{`${context.installationAddress.streetAddress}, ${context.installationAddress.suburb}, ${context.installationAddress.city}, ${context.installationAddress.province}, ${context.installationAddress.postalCode}`}</p>
            <button className="location-confirmation-change-address" onClick={changeAddressClickHandler}>Change address</button>
            <hr className="progress__hr" />
        </div>
    )
}